import { Grid, Typography } from "@mui/material"
import { InputComponent } from "../../components/input"
import { LoadingButton } from "@mui/lab"
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { AuthService } from "../../services/auth"
import { usePageTitle } from "../../hooks"

export const ForgetPassword = ({ isClient = true }: { isClient?: boolean }) => {
    usePageTitle("Recuperar acesso")

    const { state } = useLocation()
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [access, setAccess] = useState("")

    const recover = () => {
        setLoading(true)
        AuthService.recoverPassword(access, isClient ? 5 : 20)
            .then(() => navigate(isClient ? "/email-enviado" : "/parceiro/email-enviado"))
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        if (state?.access) setAccess(state?.access)
    }, [state])


    return (
        <Grid
            container
            sx={{
                height: "calc(100% - 80px)",
                display: "flex",
                gap: "2.5rem",
                flexDirection: "column",
                alignItems: "center",
                paddingBottom: "20px",
                flexWrap: "nowrap"
            }}
        >

            <Typography
                variant="h1"
                textAlign={"left"}
                width={"90%"}
            >Esqueceu a senha?</Typography>

            <Typography
                variant="body1"
                sx={{ opacity: .5 }}
                textAlign={"left"}
                width={"90%"}
            >Para alterar sua senha, informe seu CPF ou e-mail de acesso. Você receberá um e-mail para digitar sua nova senha.</Typography>

            <Grid
                sx={{
                    width: "100%",
                    display: "flex",
                    gap: "1.5rem",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <InputComponent
                    autoFocus
                    label="E-mail ou CPF"
                    value={access}
                    onChange={(e) => setAccess(e.target.value)}
                />

            </Grid>

            <LoadingButton
                variant="contained"
                loading={loading}
                onClick={recover}
            >
                Enviar
            </LoadingButton>

        </Grid>
    )
}